<template>
    <div>
        <!-- 我提交的事件  -->
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="状态:">
                            <el-select v-model="form.status" placeholder="请选择" class="common-input">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in deployStatus" :key="item.id" :label="item.cname"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="标题搜索:" >
                            <el-input v-model="form.keyword" placeholder="请输入关键字"  class="common-input"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="高危操作:">
                            <el-select v-model="form.isHighRiskOperation" placeholder="请选择" clearable class="common-input">
                                <el-option label="是" :value="1"></el-option>
                                <el-option label="否" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="报告人:">
                            <el-input type="text" placeholder="请选择报告人" disabled v-model="requesterName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getRequester } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="编号:">
                            <el-input v-model="form.serialNumber" placeholder="请输入编号" class="common-input"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="11">
                        <el-form-item label="创建时间:">
                            <el-date-picker
                                v-model="createTime"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="处理人:">
                            <el-input type="text" placeholder="请选择处理人" disabled v-model="currentHandlerName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getCurrentHandler } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="环境:">
                            <el-select v-model="form.env" placeholder="请选择" class="common-input">
                                <el-option v-for="item in env" :key="item.id" :label="item.cname"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="项目名称:">
                            <el-select v-model="form.projectName" placeholder="请选择" class="common-input">
                                <el-option v-for="item in projectName" :key="item.id" :label="item.cname"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="服务请求:">
                            <el-select v-model="form.serviceClass" placeholder="请选择" class="common-input" popper-class="serviceClass" filterable>
                                <el-option v-for="item in serviceClass" :key="item.id" :label="item.cname"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" style="float: right">
                        <el-form-item label="参与人:">
                            <el-input type="text" placeholder="请选择参与人" disabled v-model="participantName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getParticipant } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button type="primary" @click="loadData">查询</el-button>
                            <el-button type="primary" @click="reset">重置</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" style="float: right">
                        <el-form-item label="指派人:">
                            <el-input type="text" placeholder="请选择指派人" disabled v-model="designatorName" class="people-input"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { callback:getDesignator } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card>
            <el-table :data="tableData" v-loading="loading" >
                <el-table-column label="序号" width="70" align="center" fixed>
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="编号" prop="serialNumber" fixed></el-table-column>
                <el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
                <el-table-column label="分类" prop="category">
                    <template slot-scope="scope">
                        {{scope.row.category | tableVal(categoryList,'t')}}
                    </template>
                </el-table-column>
                <el-table-column label="报告人" prop="requester"></el-table-column>
                <el-table-column label="参与人" prop="participant" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.participant | showParticipant(scope.row.participant )}}
                    </template>
                </el-table-column>
                <el-table-column label="指派人" prop="designator"></el-table-column>
                <el-table-column label="处理人" prop="currentHandler"></el-table-column>
                <el-table-column label="所属部门" prop="currentDepartment"></el-table-column>
                <el-table-column label="状态" prop="status">
                    <template slot-scope="scope">
                        {{ scope.row.status | tableVal(deployStatus) }}
                    </template>
                </el-table-column>
                <el-table-column label="环境">
                    <template slot-scope="scope">
                        {{ scope.row.env | tableVal(env) }}
                    </template>
                </el-table-column>
                <el-table-column label="项目名称">
                    <template slot-scope="scope">
                        {{ scope.row.projectName | tableVal(projectName) }}
                    </template>
                </el-table-column>
                <el-table-column label="服务请求">
                    <template slot-scope="scope">
                        {{ scope.row.serviceClass | tableVal(serviceClass) }}
                    </template>
                </el-table-column>
                <el-table-column label="高危操作">
                    <template slot-scope="scope">
                        {{ scope.row.isHighRiskOperation ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/deployAdd',
                        query: { type:'edit',serialNumber:scope.row.serialNumber,callback:request }}">
                            <el-button type="text" v-if="user==scope.row.currentHandlerId&&scope.row.status!='323'&&scope.row.status!='451'&&scope.row.status!='489'&&scope.row.status!='491'">修改</el-button>
                        </router-link>
                        <router-link :to="{ path: '/deployDetail',
                        query: { serialNumber:scope.row.serialNumber }}">
                            <el-button type="text">详情</el-button>
                        </router-link>
                        <el-button v-if="scope.row.status=='513'" class="table-del-btn" type="text" @click="deleteRole(scope.row)" v-w-role="'ITSM-0060'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    import services from "./deploy.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    status:"",
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                    serialNumber:'',
                    start_time:'',
                    stop_time:'',
                    requester:'',
                    currentHandler:'',
                    participant:'',
                    designator:'',
                    env:'',  //环境
                    projectName:'',//项目名称
                    serviceClass:'',//服务请求
                    isHighRiskOperation: '' //高危操作
                },
                total:null,
                tableData:[],
                loading:true,
                ExportBtn:false,
                categoryList:[],     // 发布分类
                requesterName:'',
                currentHandlerName:'',
                participantName:'',
                designatorName:'',
                createTime:[],
            }
        },
        created() {
            this.request();
            this.getUserId()
            this.getCategoryList();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            deployStatus(){
                return this.dictionary.deploy_status;
            },
            deployTypeId(){
                return this.$store.state.caseType.deploy;
            },
            user(){
                return window.localStorage.getItem('internalUserid')
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },

        },
        methods: {
            //获取发布分类
            getCategoryList(){
                commonService.categoryList(this.deployTypeId.id).then(res => {
                    this.categoryList = res;
                })
            },
            getUserId(){
                this.userName=localStorage.getItem('internalUserid')
            },
            loadData(){
                this.loading = true;
                this.form.pageIndex=1
                this.form={
                    ...this.form,
                    start_time: this.createTime[0],
                    stop_time:this.createTime[1]
                }
                this.request();
            },
            //重置
            reset(){
                this.form={
                    status:"",
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                    serialNumber:'',
                    start_time:'',
                    stop_time:'',
                    requester:'',
                    currentHandler:'',
                    participant:'',
                    designator:'',
                    env:'',  //环境
                    projectName:'',//项目名称
                    serviceClass:'',//服务请求
                    isHighRiskOperation: '' //高危操作
                }
                this.requesterName=''
                this.currentHandlerName=''
                this.participantName=''
                this.designatorName=''
                this.createTime=[]
            },
            //选择的指派人
            getDesignator(obj){
                this.designatorName=obj.name
                this.form={
                    ...this.form,
                    designator:obj.internalUserid
                }
            },
            // 选择的请求人
            getRequester(obj){
                this.requesterName=obj.name
                this.form = {
                    ...this.form,
                    requester:obj.internalUserid
                }
            },
            //选择的处理人
            getCurrentHandler(obj){
                this.currentHandlerName=obj.name
                this.form={
                    ...this.form,
                    currentHandler:obj.internalUserid
                }
            },
            //选择的参与人
            getParticipant(obj){
                this.participantName=obj.name
                this.form={
                    ...this.form,
                    participant:obj.internalUserid
                }
            },
            request(){
                // 获取列表数据
                let params = {
                    ...this.form,
                    filterCondition:"tome",
                    userName:this.userName
                }
                services.getList(params).then(res => {
                    this.tableData = res.deployTable;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deteleDeploy({ serialNumber:row.serialNumber }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
